<template>
    <div class="container-fluid">
        <div class="bg"></div>
        <div class="verify-id-container register-container col-md-4 offset-md-4 col-10 offset-1" :style="{ display: verify_div_display}">
            <h2 class="register-title ">เลขประจำตัวนักเรียน</h2>
            <form class="verify-from">
                <input type="text" class="form-input col-md-6 offset-md-1 col-10" v-model="studentid" required>
                <input type="button" value="ต่อไป" class="form-btn" @click="checkStudentID();">
            </form>
            <span style="color: red;">{{ checkStudentIDalert }}</span>
        </div>
        <div class="info-form-container register-container col-md-6 offset-md-3 col-10 offset-1" :style="{ display: info_div_display}">
            <form class="info-form">
                <h2 class="info-title ">ข้อมูลส่วนตัว</h2>
                <div class="input-group col-md-4">
                    <label for="name">ชื่อ</label>
                    <input type="text" placeholder="ไม่ต้องใส่คำนำหน้า" class="form-input" v-model="name">
                </div>
                <div class="input-group col-md-4">
                    <label for="surname">นามสกุล</label>
                    <input type="text" class="form-input" v-model="surname">
                </div>
                <div class="input-group col-md-3">
                    <label for="nickname">ชื่อเล่น</label>
                    <input type="text" class="form-input" v-model="nickname">
                </div>
                <div class="input-group col-md-4">
                    <label for="classlevel">ระดับชั้น</label>
                    <select class="form-input" v-model="classlevel">
                        <option value="ม.1">ม.1</option>
                        <option value="ม.2">ม.2</option>
                        <option value="ม.3">ม.3</option>
                        <option value="ม.4">ม.4</option>
                        <option value="ม.5">ม.5</option>
                        <option value="ม.6">ม.6</option>
                    </select>
                </div>
                <div class="input-group col-md-4">
                    <label for="classroom">ห้อง</label>
                    <input type="text" class="form-input" v-model="classroom" placeholder="เช่นอยู่ 1/3 ใส่แค่ 3">
                </div>
                <div class="input-group col-md-3">
                    <label for="religion">ศาสนา</label>
                    <select class="form-input" v-model="religion">
                        <option value="พุทธ">พุทธ</option>
                        <option value="อิสลาม">อิสลาม</option>
                        <option value="คริสต์">คริสต์</option>
                    </select>
                </div>
                <div class="input-group col-md-7">
                    <label for="phone">เบอร์โทรศัพท์</label>
                    <input type="text" class="form-input" v-model="phone">
                </div>
                <div class="input-group col-md-4">
                    <label for="lineid">Line ID</label>
                    <input type="text" class="form-input" v-model="lineid">
                </div>
                <div class="input-group col-md-11">
                    <label for="fburl">Facebook (www.facebook.com/<span style="color: red;">inwzaa</span>)</label>
                    <input type="text" placeholder="นำลิงค์มาจาก Timeline มาใส่หรือชื่อเฟสก็ได้" class="form-input" v-model="fburl">
                </div>
                <div class="input-group col-md-5">
                    <label for="medical">โรคประจำตัว (หากไม่มีใส่ -)</label>
                    <input type="text" class="form-input" v-model="medical">
                </div>
                <div class="input-group col-md-6">
                    <label for="allergy">สิ่งที่แพ้ (หากไม่มีใส่ -)</label>
                    <input type="text" class="form-input" v-model="allergy">
                </div>
                <div class="input-group col-md-5">
                    <label for="name_parent">ชื่อผู้ปกครอง</label>
                    <input type="text" class="form-input" v-model="name_parent">
                </div>
                <div class="input-group col-md-6">
                    <label for="surname_parent">นามสกุลผู้ปกครอง</label>
                    <input type="text" class="form-input" v-model="surname_parent">
                </div>
                <div class="input-group col-md-5">
                    <label for="relation">ความสัมพันธ์</label>
                    <input type="text" class="form-input" v-model="relation">
                </div>
                <div class="input-group col-md-6">
                    <label for="phone_parent">เบอร์โทรศัพท์ผู้ปกครอง</label>
                    <input type="text" class="form-input" v-model="phone_parent">
                </div>
            </form>
            <input type="button" value="ต่อไป" class="form-btn" @click="checkInfo();">
            <br>
            <span style="color: red;">{{ checkInfoAlert }}</span>

        </div>
        <div class="question-form-container register-container col-md-6 offset-md-3 col-10 offset-1" :style="{ display: question_div_display}">
            <form class="question-form">
                <h2 class="register-title ">คำถาม</h2>
                <div class="input-group col-md-12">
                    <label for="question1">1. {{ questionDetail_1 }}</label>
                    <textarea rows="3" class="form-input" v-model="qAnswer_1">
                    </textarea>
                </div>
                <div class="input-group col-md-12">
                    <label for="question2">2. {{ questionDetail_2 }}</label>
                    <textarea rows="3" class="form-input" v-model="qAnswer_2">
                    </textarea>
                </div>
            </form>
            <input type="button" value="ย้อนกลับ" class="form-btn" @click="questionNavPrev();">
            <input type="button" value="ต่อไป" class="form-btn" @click="questionNavNext();">
            <br>
            <span style="color: red;">{{ checkQuestionAlert }}</span>
        </div>
        <div class="summary-form-container register-container col-md-6 offset-md-3 col-10 offset-1" :style="{ display: summary_div_display}">
            <h2 class="register-title ">ตรวจสอบข้อมูล</h2>
            <div class="input-group col-md-5">
                <label for="studentid">เลขประจำตัวนักเรียน</label>
                <input type="text" class="form-input form-input-check" disabled v-model="studentid">
            </div>
            <div class="input-group col-md-6">
                <label for="branch">วิชาที่เลือก</label>
                <input type="text" class="form-input form-input-check" disabled v-model="branch">
            </div>
            <div class="input-group col-md-4">
                <label for="name">ชื่อ</label>
                <input type="text" placeholder="ไม่ต้องใส่คำนำหน้า" class="form-input form-input-check" disabled v-model="name">
            </div>
            <div class="input-group col-md-4">
                <label for="surname">นามสกุล</label>
                <input type="text" class="form-input form-input-check" disabled v-model="surname">
            </div>
            <div class="input-group col-md-3">
                <label for="nickname">ชื่อเล่น</label>
                <input type="text" class="form-input form-input-check" disabled v-model="nickname">
            </div>
            <div class="input-group col-md-4">
                <label for="classlevel">ระดับชั้น</label>
                <input type="text" class="form-input form-input-check" disabled v-model="classlevel">
            </div>
            <div class="input-group col-md-4">
                <label for="classroom">ห้อง</label>
                <input type="text" class="form-input form-input-check" disabled v-model="classroom">
            </div>
            <div class="input-group col-md-3">
                <label for="religion">ศาสนา</label>
                <input type="text" class="form-input form-input-check" disabled v-model="religion">
            </div>
            <div class="input-group col-md-7">
                <label for="phone">เบอร์โทรศัพท์</label>
                <input type="text" class="form-input form-input-check" disabled v-model="phone">
            </div>
            <div class="input-group col-md-4">
                <label for="lineid">Line ID</label>
                <input type="text" class="form-input form-input-check" disabled v-model="lineid">
            </div>
            <div class="input-group col-md-11">
                <label for="fburl">Facebook (www.facebook.com/
                    <span style="color: red;">inwzaa</span>)</label>
                <input type="text" placeholder="นำลิงค์มาจาก Timeline มาใส่" class="form-input form-input-check" disabled v-model="fburl">
            </div>
            <div class="input-group col-md-5">
                <label for="medical">โรคประจำตัว (ถ้ามี)</label>
                <input type="text" class="form-input form-input-check" disabled v-model="medical">
            </div>
            <div class="input-group col-md-6">
                <label for="allergy">สิ่งที่แพ้ (ถ้ามี)</label>
                <input type="text" class="form-input form-input-check" disabled v-model="allergy">
            </div>
            <div class="input-group col-md-5">
                <label for="name_parent">ชื่อผู้ปกครอง</label>
                <input type="text" class="form-input form-input-check" disabled v-model="name_parent">
            </div>
            <div class="input-group col-md-6">
                <label for="surname_parent">นามสกุลผู้ปกครอง</label>
                <input type="text" class="form-input form-input-check" disabled v-model="surname_parent">
            </div>
            <div class="input-group col-md-5">
                <label for="relation">ความสัมพันธ์</label>
                <input type="text" class="form-input form-input-check" disabled v-model="relation">
            </div>
            <div class="input-group col-md-6">
                <label for="phone_parent">เบอร์โทรศัพท์ผู้ปกครอง</label>
                <input type="text" class="form-input form-input-check" disabled v-model="phone_parent">
            </div>
            <div class="input-group col-md-11">
                <label for="question1">1. {{ questionDetail_1 }}</label>
                <textarea rows="3" class="form-input form-input-check" disabled v-model="qAnswer_1">
                </textarea>
            </div>
            <div class="input-group col-md-11">
                <label for="question2">2. {{ questionDetail_2 }}</label>
                <textarea rows="3" class="form-input form-input-check" disabled v-model="qAnswer_2">
                </textarea>
            </div>
            <input type="button" value="แก้ไขข้อมูล" class="form-btn" @click="summaryNavEdit();">
            <input type="button" value="ยืนยันการสมัคร" class="form-btn" @click="summaryNavSubmit();">
        </div>
        <div class="success-container register-container col-md-4 offset-md-4 col-10 offset-1" :style="{ display: success_div_display}">
            <h2 class="register-title ">สมัครเรียบร้อย</h2>
            <h5>ประกาศผล 10 สิงหาคม</h5>
            <h6>ติดตามได้ที่เว็บ
                <a href="http://dekcom.tsn.ac.th">dekcom.tsn.ac.th</a>
            </h6>
            <h6 style="margin-bottom: 12px;">Facebook :
                <a href="https://www.facebook.com/DekComCamp/">DekCom Mini Camp</a>
            </h6>
            <a href="/" class="form-btn">กลับหน้าแรก</a>
        </div>
    </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/database";
export default {
  name: "Register",
  data() {
    return {
      // Display container control
      verify_div_display: "block",
      info_div_display: "none",
      question_div_display: "none",
      summary_div_display: "none",
      success_div_display: "none",

      // Info
      branch: this.$route.params.branchs,
      studentid: "",
      name: "",
      surname: "",
      nickname: "",
      classlevel: "",
      classroom: "",
      religion: "",
      phone: "",
      lineid: "",
      fburl: "",
      medical: "",
      allergy: "",
      name_parent: "",
      surname_parent: "",
      relation: "",
      phone_parent: "",

      // Check answer input from
      checkStudentIDalert: "",
      checkInfoAlert: "",
      checkQuestionAlert: "",

      // Question Branch
      questionDetail_1: "",
      questionDetail_2: "",

      // Question Answer
      qAnswer_1: "",
      qAnswer_2: ""
    };
  },
  methods: {
    checkStudentID() {
      firebase
        .database()
        .ref("users/" + this.studentid + "/studentid")
        .once("value", snapshot => {
          if (snapshot.exists()) {
            this.checkStudentIDalert = "รหัสประจำตัวนี้สมัครแล้ว";
          } else {
            // Hide Verify div and Display Info div
            this.verify_div_display = "none";
            this.info_div_display = "block";
          }
        });
    },
    checkInfo() {
      if (
        this.name === "" ||
        this.surname === "" ||
        this.nickname === "" ||
        this.classlevel === "" ||
        this.classroom === "" ||
        this.religion === "" ||
        this.phone === "" ||
        this.lineid === "" ||
        this.fburl === "" ||
        this.allergy === "" ||
        this.medical === "" ||
        this.name_parent === "" ||
        this.surname_parent === "" ||
        this.relation === "" ||
        this.phone_parent === ""
      ) {
        this.checkInfoAlert = "กรุณาใส่ข้อมูลให้ครบทุกช่อง";
      } else {
        // Hide Info div and Display Question div
        this.info_div_display = "none";
        this.question_div_display = "block";
      }
    },

    // Question
    questionNavPrev() {
      // Hide Question div and Display Info div
      this.info_div_display = "block";
      this.question_div_display = "none";
    },
    questionNavNext() {
      if (this.checkQuestionAnswer()) {
        this.question_div_display = "none";
        this.summary_div_display = "block";
      } else {
        this.checkQuestionAlert = "กรุณาใส่ข้อมูลให้ครบทุกช่อง";
      }
    },
    checkQuestionAnswer() {
      if (this.qAnswer_1 === "" || this.qAnswer_2 === "") {
        return false;
      } else {
        return true;
      }
    },

    // Summary
    summaryNavEdit() {
      // Hide summary div and question Info div
      this.question_div_display = "block";
      this.summary_div_display = "none";
    },
    summaryNavSubmit() {
      // Save Data to database
      firebase
        .database()
        .ref("users")
        .child(this.studentid)
        .set({
          studentid: this.studentid,
          branch: this.branch,
          name: this.name,
          surname: this.surname,
          nickname: this.nickname,
          classlevel: this.classlevel,
          classroom: this.classroom,
          religion: this.religion,
          phone: this.phone,
          lineid: this.lineid,
          fburl: this.fburl,
          medical: this.medical,
          allergy: this.allergy,
          name_parent: this.name_parent,
          surname_parent: this.surname_parent,
          relation: this.relation,
          phone_parent: this.phone_parent,
          qAnswer_1: this.qAnswer_1,
          qAnswer_2: this.qAnswer_2
        });

      // Show success alert
      this.summary_div_display = "none";
      this.success_div_display = "block";
    }
  },
  mounted() {
    //Get Question from DB
    firebase
      .database()
      .ref("question/" + this.branch.toLowerCase())
      .on("value", snapshot => {
        this.questionDetail_1 = snapshot.val().question1;
        this.questionDetail_2 = snapshot.val().question2;
      });
  }
};
</script>

<style lang='scss' scoped>
.container-fluid {
  padding: 0;
}

.bg {
  background: url("/static/assets/img/register_bg.jpg") center no-repeat fixed;
  background-size: cover;
  min-width: 100vw;
  min-height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
}

input {
  font-family: "Kanit";
}

label {
  margin: 0;
}

.input-group {
  padding: 5px;
  display: inline-block;
  text-align: left;
}

.form-btn {
  font-family: "Kanit";
  background: #212d45;
  // background: linear-gradient(90deg,#323598 10%,#5155fe 90%);
  border: 0;
  border-radius: 20px;
  font-size: 16px;
  padding: 5px 20px;
  margin: 10px;
  color: #fff;
  cursor: pointer;
  transition: 0.3s ease;
  &:hover {
    background: #3b4055;
  }
}

.form-input {
  background: #fff;
  width: 100%;
  // height: 30px;
  border: 2px solid #3c3c3c;
  padding: 2px 5px;
  border-radius: 5px;
  font-size: 14px;
}

.form-input-check {
  background: #ececec;
}

.register-container {
  background: #fff;
  border-radius: 5px;
  padding: 15px;
  text-align: center;
  box-shadow: 0 0 10px #fff;
  color: #212d45;
  margin: 80px auto;
  transition: 0.3s ease;
}

.register-title {
  margin: 0;
  padding: 5px 0;
}

/* Verify */

/* Info Form */

/* Question Camp */

/* Summary */

/* Success */
</style>



// WEBPACK FOOTER //
// src/components/Register.vue